import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import PhotographyCategories from "../components/PhotographyCategories";
import Rental from "../components/Rental";
import Contact from "../components/Contact";


function Home() {
  return (
    <main>

      <Hero />

      <About />

      <Services />

      <PhotographyCategories />
      <Rental/>
      <Contact/>
      

    </main>
  );
}

export default Home;